<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="模板跟踪" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="800px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" label-width="70px">
        <el-form-item label="" class="input-with-col100 mr0">
          <el-tabs v-model="ruleListValue" type="card" style="width: 100%;" @tab-click="handleChoose">
            <el-tab-pane :key="item.uuid" v-for="(item, index) in ruleList" :name="item.uuid">
              <span slot="label">
                <div v-if="item.uuid == ruleListValue">
                  <el-input placeholder="请输入名称" :ref="item.uuid" size="mini" v-model="item.title"
                    style="width: 100px;"></el-input>
                  <i class="el-icon-delete-solid" style="color: red;cursor: pointer;" @click="handleDel(index)"></i>
                  <i class="el-icon-circle-plus" style="color: #5b8cff; cursor: pointer;"
                    @click="handleAdd(index, item)"></i>
                </div>
                <span v-else>{{ item.title || '[请输入名称]' }}</span>
              </span>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>

        <div class="tag-flex">
          <div v-for="(item, index) in chooseItem.childList" :key="item.uuid">
            <el-input :ref="item.uuid" size="mini" placeholder="请输入" v-model="item.subNodeTitle"
              style="width: 100px;"></el-input><i class="el-icon-delete-solid"
              style="color: red;cursor: pointer;margin-right: 20px;margin-left: 10px;font-size: 16px;"
              @click="handleDelTag(index)"></i>
          </div>
          <el-button size="mini" type="primary" @click="handleAddTag">添加信息</el-button>
        </div>
        <el-form-item label="" label-width="130px" class="input-with-col8 label-with-eight-word mr0">

        </el-form-item>
        <el-form-item label="是否需要上传附件：" label-width="130px" class="input-with-col8 label-with-eight-word mr0">
          <el-radio-group v-model="chooseItem.needFile">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="需要上传附件内容：" label-width="130px" class="input-with-col8 label-with-eight-word mr0">
          <i class="el-icon-circle-plus" style="color: #5b8cff; cursor: pointer;font-size: 24px;"
            @click="handleAddFile(index)"></i>
        </el-form-item>
        <div>
          <div v-for="(item, index) in chooseItem.fileNodeDTOList" :key="item.uuid">
            <el-input :ref="item.uuid" size="mini" placeholder="请输入" v-model="item.fileNodeTitle" style="width: 100%;">
              <i class="el-icon-delete-solid" slot="append"
                style="color: red;cursor: pointer;margin-right: 20px;margin-left: 10px;font-size: 16px;"
                @click="handleDelFile(index)"></i></el-input>
          </div>
        </div>
        <el-form-item label="需要填写的信息：" label-width="130px" class="input-with-col8 label-with-eight-word mr0">
          <i class="el-icon-circle-plus" style="color: #5b8cff; cursor: pointer;font-size: 24px;"
            @click="handleAddMessage(index)"></i>
        </el-form-item>
        <div>
          <div v-for="(item, index) in chooseItem.messageNodeDTOList" :key="item.uuid">
            <el-input :ref="item.uuid" size="mini" placeholder="请输入" v-model="item.title" style="width: 100%;">
              <i class="el-icon-delete-solid" slot="append"
                style="color: red;cursor: pointer;margin-right: 20px;margin-left: 10px;font-size: 16px;"
                @click="handleDelMessage(index)"></i></el-input>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" :loading="loading" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveData, getDetail } from "@/api/salesManagement/whmb.js";
import { v4 as uuidv4 } from "uuid";
export default {
  data() {
    return {
      ruleListValue: null,
      ruleList: [],
      form: {

      },
      loading: false,
      chooseItem: {}
    };
  },
  props: {
    clientForm: {
      type: Object,
      required: false,
      default: () => ({
        templateName: "",
        remark: "",
        id: "",
      }),
    },
  },

  created() {


    if (this.clientForm.id) {
      this.getDetailFun()
      console.log(this.ruleList)
    }
  },

  methods: {
    async getDetailFun() {
      const res = await getDetail(this.clientForm.id)
      console.log(res)
      if (!res.data.ruleList || !res.data.ruleList.length) {
        const uuid = uuidv4()
        this.ruleList.push({
          title: '',
          childList: [
            {
              uuid: uuidv4(),
              subNodeTitle: ''
            }
          ],
          fileNodeDTOList: [
            {
              fileNodeTitle: '',
              uuid: uuidv4(),
            }
          ],
          messageNodeDTOList: [
            {
              title: '',
              uuid: uuidv4(),
            }
          ],
          needFile: false,
          uuid
        })
        this.ruleListValue = uuid;
        this.chooseItem = this.ruleList[0]
      } else {
        const ruleListArr = res.data.ruleList.map(item => {
          if (item.childList && item.childList.length) {
            item.childList.forEach(it=>it.uuid = it.subNodeId)
          }
          if (item.fileNodeDTOList && item.fileNodeDTOList.length) {
            item.fileNodeDTOList.forEach(it=>it.uuid = it.fileNodeId)
          } else {
            item.fileNodeDTOList = []
          }
          if (item.messageNodeDTOList && item.messageNodeDTOList.length) {
            item.messageNodeDTOList.forEach(it=>it.uuid = it.messageId)
          } else {
            item.messageNodeDTOList = []
          }
          item.uuid = item.nodeId
          return item;
        });;
        this.chooseItem = ruleListArr[0]
        this.ruleListValue = ruleListArr[0].uuid
        this.ruleList = ruleListArr

      }
    },
    handleChoose(v, e) {
      this.$nextTick(() => {
        if (this.$refs[v._props.name]) {
          this.$refs[v._props.name][0].focus()
        }
        const item = this.ruleList.find(item => item.uuid === this.ruleListValue)
        this.chooseItem = item
      })
    },
    handleAdd(index) {
      const uuid = uuidv4()
      const obj = {
        title: '',
        childList: [
          {
            uuid: uuidv4(),
            subNodeTitle: ''
          }
        ],
        fileNodeDTOList: [
          {
            fileNodeTitle: '',
            uuid: uuidv4(),
          }
        ],
        needFile: false,
        uuid
      }
      this.ruleList.splice(index + 1, 0, obj);
      this.$nextTick(() => {
        this.ruleListValue = uuid
        console.log(this.ruleListValue)
      })
    },
    handleAddTag(index) {
      this.chooseItem.childList.push({
        subNodeTitle: '',
        uuid: uuidv4(),
      });
    },
    handleAddFile() {
      this.chooseItem.fileNodeDTOList.push({
        fileNodeTitle: '',
        uuid: uuidv4(),
      });
    },
    handleAddMessage() {
      console.log(this.chooseItem.messageNodeDTOList)
      this.chooseItem.messageNodeDTOList.push({
        title: '',
        uuid: uuidv4(),
      });
    },
    handleDel(index) {
      if (this.ruleList.length <= 1) {
        this.$message.warning("至少要有一项")
        return
      }
      this.ruleList.splice(index, 1);
    },
    handleDelTag(index) {
      if (this.chooseItem.childList.length <= 1) {
        this.$message.warning("至少要有一项")
        return
      }
      this.chooseItem.childList.splice(index, 1);
    },
    handleDelFile(index) {
      if (this.chooseItem.fileNodeDTOList.length <= 1) {
        this.$message.warning("至少要有一项")
        return
      }
      this.chooseItem.fileNodeDTOList.splice(index, 1);
    },
    handleDelMessage(index) {
      if (this.chooseItem.messageNodeDTOList.length <= 1) {
        this.$message.warning("至少要有一项")
        return
      }
      this.chooseItem.messageNodeDTOList.splice(index, 1);
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    chooseProject() {
      this.form.liftIdList = null;
    },
    async handleConfirm() {
      console.log(this.ruleList, this.clientForm)
      const params = { ruleList: this.ruleList, ...this.clientForm }
      this.loading = true;
      const res = await saveData(params);
      if (res.code === 200) {
        this.$message.success("保存成功");
        this.$emit("confirm");
      }
      this.loading = false;
      // this.$refs["form"].validate(async (valid) => {
      //   if (valid) {
      //     const params = {
      //       ...this.form,
      //     };
      //     this.loading = true;
      //     const res = await bindLift(params);
      //     if (res.code === 200) {
      //       this.$message.success("保存成功");
      //       this.$emit("confirm");
      //     }
      //     this.loading = false;
      //   }
      // });

    },
  },


};
</script>

<style scoped lang="scss">
.tag-flex {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/whmb/components/AddAssigne.vue